import React from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import Spinner from "../common/spinner";
import { Link, Redirect } from "react-router-dom";
import * as queryString from 'query-string';
import { PROXY_DELETE, PROXY_APPROVED, PROXY_CANCELLED, PROXY_PENDING, EPIC, RX, GRANT, REQUEST, ACCEPT, DECLINE, RXREQUEST, REQUESTV2 } from "../../constants/textConstants";
import * as ProxyHelper from "./ProxyHelper";

class ProxyMgmtProcessing extends React.Component {
    constructor(props) {
        super(props);
        const { action, type, source, proxyrequestid, proxyname } = this.props.match.params;
        const { location, showGrantProxyAccess, enableProxyRequestV2, enableProxyRXRequestAttestation } = this.props;
        const searchParams = location && location.search ? queryString.parse(location.search) : null;
        const requestAction = searchParams ? searchParams.action : action;
        const requestType = searchParams ? searchParams.type : type;
        const proxySource = searchParams ? searchParams.source : source;
        const proxyRequestId = searchParams ? searchParams.proxyRequestId : proxyrequestid;
        const proxyName = searchParams ? searchParams.proxyName : proxyname;
        //this.requestType = requestType && requestType.toLowerCase() === GRANT ? "Grant" : requestType && requestType.toLowerCase() === REQUEST ? "Request" : "";
        this.state = {
            action: requestAction,
            requestType: requestType,
            proxySource: proxySource,
            proxyRequestId: proxyRequestId,
            proxyName: proxyName && proxyName !== 'undefined' ? proxyName : ""            
        };
        if (requestType && (requestType.toLowerCase() === GRANT && showGrantProxyAccess || (enableProxyRequestV2 && requestType.toLowerCase() === REQUESTV2) || (enableProxyRXRequestAttestation && requestType.toLowerCase() === REQUEST))) {
            this.fetchingProxyStatus = true;
            const { getProxyStatus } = this.props;
            const { proxyRequestId } = this.state;
            getProxyStatus(proxyRequestId);
        }
       
        this.invalidStatusArray = ["expired", "cancelled", "approved", "declined", "deleted"];  //if the proxy status is any of these statuses, we display full page error. 
        //Refer: Task 71451: Grantee accepts an already processed grant
    }

    componentDidMount() {
        this.mounted = true;
        const { requestType } = this.state;
        logUI(`MBHWeb.UI.ProxyMgmtProcessing.${ProxyHelper.getLogRequestType(requestType)}.ComponentDidMount`, new Date(), Tools.getURLPath());
    }

    componentDidUpdate() {
        this.fetchingProxyStatus = false;
    }

    render() {
        //Identify route and redirect to corresponding route depends on type. This way we can handle existing deeplink and routing. 
        const { proxyName, proxySource, requestType, proxyRequestId, action } = this.state;
        const { showGrantProxyAccess, proxyStatus, enableProxyRequestV2, enableProxyRXRequestAttestation } = this.props;
        
        let url = "/";
        if (requestType === GRANT)
            url = `/proxygrant/${action}/${proxyRequestId}/${proxySource}/${proxyName}`;
        else if (enableProxyRequestV2 && requestType === REQUESTV2) {
            url = `/proxyrequest/${action}/${proxyRequestId}/${proxySource}/${proxyName}`;
        }
        /*else if (enableProxyRXRequestAttestation && proxySource && proxySource.toLowerCase() === "rx") {
            url = `/acceptRxProxyTerms/${action}/${proxyRequestId}/${proxySource}/${requestType}/${proxyName}`;
        }*/
        else if (requestType === REQUEST) {
            if (action === ACCEPT) {
                url = `/rx/acceptproxy/${proxyRequestId}`;
            }
            else if (action === DECLINE) {
                url = `/rx/declineproxy/${proxyRequestId}/${proxyName}`;
            }
        }

        const status = proxyStatus && proxyStatus.response && proxyStatus.response.proxyStatus.toLowerCase();

        const type = (requestType === REQUESTV2) ? "request" : "invitation";

        const heading = status === "expired" ? `The ${type} has expired.` : status === "cancelled" ? `The ${type} is no longer available.` : (status === "approved" || "declined" || "deleted") && "Sorry, we're unable to continue.";
        const subHeading = status === "expired" ? (requestType === REQUESTV2 ? `You can ask the requestor to send another request.` : `You can ask the sender to resend the ${type} if you still need access.`) : status === "cancelled" ? "The request has been cancelled." : (status === "approved" || "declined" || "deleted") && "This request has already been processed.";

        {/*return (enableProxyRequestV2 && requestType === REQUESTV2 && proxyStatus && proxyStatus.response && (this.invalidStatusArray.indexOf(status) != -1)) ?
            <Redirect to={{
                pathname: '/invalidproxyaccess',
                state: {
                    heading: heading,
                    subHeading: subHeading
                }
            }} /> :
            requestType === REQUESTV2 && enableProxyRequestV2 && action !== DECLINE ? <Redirect to={{ pathname: `/acceptProxyTermsV2/${action}/${proxyRequestId}/${proxySource}/${requestType}/${proxyName}` }} />
                : (this.fetchingProxyStatus || proxyStatus && proxyStatus.waiting) ? <>
                    <div className="row overlay-loading-container">
                        <div className="col-12 align-self-center">
                            <Spinner />
                        </div>
                    </div>
                </> : (showGrantProxyAccess && requestType === GRANT && proxyStatus && proxyStatus.response && (this.invalidStatusArray.indexOf(status) != -1)) ?
                        <Redirect to={{
                            pathname: '/invalidproxyaccess',
                            state: {
                                heading: heading,
                                subHeading: subHeading
                            }
                        }} />
                        : <Redirect to={{ pathname: url }} />;*/}
        return (this.fetchingProxyStatus || proxyStatus && proxyStatus.waiting) ? <>
            <div className="row overlay-loading-container">
                <div className="col-12 align-self-center">
                    <Spinner />
                </div>
            </div>
        </> : ((showGrantProxyAccess && requestType === GRANT || enableProxyRequestV2 && requestType === REQUESTV2 || enableProxyRXRequestAttestation) && proxyStatus && proxyStatus.response && (this.invalidStatusArray.indexOf(status) != -1)) ? <Redirect to={{
            pathname: '/invalidproxyaccess',
            state: {
                heading: heading,
                subHeading: subHeading
            }
            }} /> : (requestType === REQUESTV2 && enableProxyRequestV2) && action !== DECLINE ? <Redirect to={{ pathname: `/acceptProxyTermsV2/${action}/${proxyRequestId}/${proxySource}/${requestType}/${proxyName}` }} /> : (enableProxyRXRequestAttestation && requestType === REQUEST && action !== DECLINE) ? <Redirect to={{ pathname: `/acceptRxProxyTerms/${action}/${proxyRequestId}/${proxySource}/${requestType}/${proxyName}` }} />: <Redirect to={{ pathname: url }} />;
    }
}

const mapStateToProps = (state) => {
    return {       
        proxyStatus: state.common[types.PROXY_STATUS],         
        showGrantProxyAccess: state.session.serverData && state.session.serverData.showGrantProxyAccess,        
        enableProxyRequestV2: state.session.serverData ? state.session.serverData.enableProxyRequestV2 : false,
        enableProxyRXRequestAttestation: state.session.serverData ? state.session.serverData.enableProxyRXRequestAttestation : false
    };
};
const mapDispatchToProps = (dispatch) => ({ 
    getProxyStatus: (proxyRequestId) =>
        dispatch({ type: types.PROXY_STATUS, data: { proxyRequestId } })   
});

export default connect(mapStateToProps, mapDispatchToProps)(ProxyMgmtProcessing);
